/**
 * Hard navigation helper.
 *
 * Thin wrapper around `window.location.replace(url)` so tests can
 * mock the call via `vi.mock('@/lib/hard-navigate', …)` —
 * `vi.spyOn(window.location, 'replace')` throws
 * "Cannot redefine property: replace" under jsdom.
 *
 * Use this (not react-router's `navigate(…)`) when the next
 * render tree MUST NOT share React state with the current tree.
 * The two shipped use sites:
 *   - DeleteRoute (F10, 2026-10-17) — after account deletion, we
 *     clear authStore + caches then hard-reload to
 *     `/auth/login?accountDeleted=1`. Client-side navigate raced
 *     against ProtectedRoute's own `<Navigate to=…?returnTo=…>`
 *     and produced a `?returnTo=/account/delete` URL in the real
 *     browser. Hard reload cancels the pending React render
 *     synchronously; no component can get a last word in.
 */
export function hardNavigate(url: string): void {
  window.location.replace(url);
}
